import React from "react";
import { Button } from "./Button";

export const CloseButton = ({ onClick, disabled, text = "" }) => {
  return (
    <Button
      style={{
        backgroundColor: "lightgray",
      }}
      disabled={disabled}
      onClick={onClick}
    >
      {text || "✖️"}
    </Button>
  );
};
